import { useState, useEffect } from "react";

const BASE_URL = "https://mis.empowerplus.in";
export const SESSION_KEY = "viewer_token";

// Module-level promise to deduplicate concurrent login calls
let _loginPromise = null;

export const silentLogin = () => {
    if (_loginPromise) return _loginPromise;
    _loginPromise = fetch(`${BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: "admin@gmail.com", password: "Admin@123" }),
    })
        .then(r => r.ok ? r.json() : null)
        .then(data => {
            const t = data?.token ?? null;
            if (t) sessionStorage.setItem(SESSION_KEY, t);
            return t;
        })
        .catch(() => null)
        .finally(() => { _loginPromise = null; });
    return _loginPromise;
};

// Returns a token immediately if available, else resolves silently in background
export const getToken = () =>
    localStorage.getItem("token") || sessionStorage.getItem(SESSION_KEY) || null;

export const getOrFetchToken = async () => {
    const t = getToken();
    if (t) return t;
    return silentLogin();
};

export function useViewerToken() {
    const [token, setToken] = useState(getToken);

    useEffect(() => {
        if (token) return;
        silentLogin().then(t => { if (t) setToken(t); });
    }, [token]);

    return token;
}
